module.exports = __webpack_public_path__ + "img/logo32.e50ed3a9.jpg";